import { createSlice } from "@reduxjs/toolkit";
import { LANGUAGES_LIST, PLUGIN_NAME } from "config/const";
import { getFromLocalStorage } from "config/functions";
import i18n from "i18n";
import moment from "moment";

const userSettingsSlice = createSlice({
  name: "userSettings",
  initialState: {
    selectedLang: LANGUAGES_LIST[0],
    selectedPlugin: PLUGIN_NAME.MICRO_CONTROLLERS,
    isLogin: true,
    user: null,
    paletteMode: "light",
    qRScanner: { open: false, callBack: () => { } },
    meterReader: { open: false, callBack: () => { } },
  },
  reducers: {
    setSelectedLang(state, action) {
      i18n.changeLanguage(action.payload?.code);
      moment.locale(action.payload?.code)

      let user = getFromLocalStorage("user");

      if (user) {
        user.lang = action.payload
        localStorage.setItem("user", JSON.stringify(user));
      }

      localStorage.setItem("selectedLang", JSON.stringify(action.payload));
      state.selectedLang = action.payload;
      // window.location.reload();
    },

    setIsLogin(state, action) { state.isLogin = action.payload },
    setUser(state, action) { state.user = action.payload },
    setQRScanner(state, action) { state.qRScanner = action.payload },
    setMeterReader(state, action) { state.meterReader = action.payload },
    setSelectedPlugin(state, action) {
      localStorage.setItem("selectedPlugin", action.payload);
      state.selectedPlugin = action.payload
    },
    setPaletteMode(state, action) {
      localStorage.setItem("paletteMode", action.payload);
      state.paletteMode = action.payload
    },
  },
});

export const {
  setSelectedLang,
  setSelectedPlugin,
  setPaletteMode,
  setIsLogin,
  setUser,
  setQRScanner,
  setMeterReader
} = userSettingsSlice.actions;
export default userSettingsSlice.reducer;
